export default __webpack_public_path__ + "static/media/Messages.e3498b86.svg";